import clsx from "clsx";
import React, { useState } from "react";
import Checkbox from "web/react/components/checkbox/checkbox";
import CookieReadMoreModal from "web/react/components/cookie-read-more-modal/cookie-read-more-modal";
import { gettext } from "web/script/modules/django-i18n";
import * as styles from "./cookie-settings-option.css";

interface CookieSettingsOptionProps {
    optionID: string;
    optionTitle: string;
    isEssential: boolean;
    cookieDescription: string;
    isSelected?: boolean;
    onChange?: () => void;
}

export default function CookieSettingsOption({
    optionID,
    optionTitle,
    isEssential,
    cookieDescription,
    isSelected,
    onChange,
}: CookieSettingsOptionProps): JSX.Element {
    const [readMoreIsOpen, setReadMoreIsOpen] = useState(false);
    function openReadMore(): void {
        setReadMoreIsOpen(true);
    }

    function closeReadMore(): void {
        setReadMoreIsOpen(false);
    }

    let cookieStatusFragment;
    if (isEssential) {
        cookieStatusFragment = (
            <div className={styles.cookieStatus}>
                {gettext("cookie_notification.cookie_settings.required_always_on.label")}
            </div>
        );
    } else {
        cookieStatusFragment = (
            <Checkbox
                elementID={optionID}
                defaultValue={isSelected}
                onChange={onChange}
                className={styles.cookieStatus}
            />
        );
    }

    return (
        <div className={styles.cookieOption}>
            <div className={styles.cookieDetails}>
                <div className={styles.cookieTitle}>{optionTitle}</div>
                {cookieStatusFragment}
            </div>
            <a className={clsx(styles.cookieReadMore, styles.link)} onClick={openReadMore}>
                {gettext("general.read_more")}
            </a>
            <CookieReadMoreModal
                isOpen={readMoreIsOpen}
                onModalClose={closeReadMore}
                title={optionTitle}
                content={cookieDescription}
            />
        </div>
    );
}
